import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MakersiteService } from '@services/makersite.service';

@Component({
  selector: 'selection-dialog',
  templateUrl: './selection-dialog.component.html',
  styleUrls: ['./selection-dialog.component.scss'],
  standalone: true,
})
export class SelectionDialogComponent implements OnInit {
  options = [];
  selectionError: any;
  header = 'Tools';
  description: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SelectionDialogComponent>,
    private makersiteService: MakersiteService,
  ) { }

  ngOnInit(): void {
    if (this.data.header) this.header = this.data.header;
    if (this.data.description) this.description = this.data.description;

    this.makersiteService.getBaseData(this.data.url).subscribe((res: any) => {
      this.options = res;
    });
  }

  showSelected(data) {
    this.dialogRef.close(data);
  }
}
